<template>
  <v-form v-bind="this.$attrs">
    <v-row class="d-flex justify-end ma-2">
      <v-col cols="12" md="3">
        <AutocompleteSubjectGroup v-model="grade" return-object label="Khối" outlined dense hide-details clearable />
      </v-col>
      <v-col cols="12" md="3">
        <SelectAcademicLevel
          v-model="classes"
          clear-icon="mdi-close"
          label="Lớp"
          clearable
          flat
          outlined
          dense
          return-object
          hide-details
          @change="classChanged"
        />
      </v-col>
      <v-col cols="12" md="3">
        <AutocompleteTeacherCard
          :syncedValue.sync="teacher"
          item-text="name"
          clear-icon="mdi-close"
          label="Giáo viên"
          outlined
          dense
          deletable-chips
          hide-details
          :displaySubjectGroup="true"
          :filter="teacherFilter"
        />
      </v-col>
      <v-col cols="12" md="3" class="d-flex justify-end">
        <v-btn class="search-button" @click="onFilter" outlined> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
    <div
      class="d-flex justify-end align-center mx-4 mb-4"
      :class="{ 'justify-space-between': isAdvancedSearchEnabled }"
    >
      <ExcelImport v-show="isAdvancedSearchEnabled" @onDataImported="onDataImported" type="teacher" />
      <div
        class="text-none primary--text"
        style="cursor: pointer; user-select: none;"
        @click="isAdvancedSearchEnabled = !isAdvancedSearchEnabled"
      >
        {{ isAdvancedSearchEnabled ? 'Ẩn chọn theo excel' : 'Chọn theo excel' }}
      </div>
    </div>
  </v-form>
</template>

<script>
import SelectAcademicLevel from '@/components/basic/input/SelectAcademicLevel'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup.vue'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import ExcelImport from '@/modules/excel-import/index.vue'

import { mapActions } from 'vuex'
import { get } from 'lodash'

export default {
  data() {
    return {
      academicLevel: null,
      subjectGroup: null,
      teacher: null,
      isAdvancedSearchEnabled: false
    }
  },
  components: {
    AutocompleteTeacherCard,
    SelectAcademicLevel,
    AutocompleteSubjectGroup,
    ExcelImport
  },
  computed: {
    teacherFilter() {
      return {
        academicLevels: get(this.academicLevel, 'id'),
        subjectGroup: get(this.subjectGroup, 'id')
      }
    }
  },
  methods: {
    ...mapActions('PostCreateAuto', ['fetchTeacherByCodeToSelectedList']),
    async onFilter() {
      const params = {
        currentClass: get(this.classes, 'id'),
        grade: get(this.grade, 'id'),
        id: get(this.student, 'id')
      }
      await this.searchStudents(params)
    },
    async onDataImported(data = []) {
      await this.fetchTeacherByCodeToSelectedList({ codes: data.map(x => x.code) })
      this.$emit('on-excel-import')
    },
    academicLevelChanged(data) {
      this.academicLevel = data
      this.teacher = null
    },
    subjectGroupChanged(data) {
      this.subjectGroup = data
      if (get(data, 'id')) this.teacher = null
    }
  }
}
</script>
